module.exports = __webpack_public_path__ + "static/media/mastercard-color.4557829e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/mastercard-color.svg
// module id = 854
// module chunks = 7